import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const SettingsSliders = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8.17188 16.9327C9.68203 16.9327 10.9063 15.7058 10.9063 14.1923C10.9063 12.6788 9.68203 11.4519 8.17188 11.4519M8.17188 16.9327C6.66172 16.9327 5.4375 15.7058 5.4375 14.1923C5.4375 12.6788 6.66172 11.4519 8.17188 11.4519M8.17188 16.9327L8.17185 19.125M8.17188 11.4519L8.17185 4.87503" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M15.8281 12.5481C17.3382 12.5481 18.5625 11.3212 18.5625 9.80769C18.5625 8.29422 17.3382 7.06731 15.8281 7.06731M15.8281 12.5481C14.3179 12.5481 13.0937 11.3212 13.0937 9.80769C13.0937 8.29422 14.3179 7.06731 15.8281 7.06731M15.8281 12.5481L15.8281 19.125M15.8281 7.06731L15.8281 4.875" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="outline">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { SettingsSliders };